import ReactTimePicker from "rc-time-picker";
import classNames from "classnames";
import React from "react";
import moment from "moment";
import { noop } from "lodash";

export const TimePicker = ({
  className,
  onFocus,
  value,
  onChange = noop,
  onBlur,
  showSecond = false,
  ...props
}) => (
  <ReactTimePicker
    onClose={onBlur}
    onOpen={onFocus}
    className={classNames("local-rc-time-picker", className)}
    onChange={(v) => onChange(v ? v.format() : null)}
    value={value ? moment(value) : null}
    showSecond={showSecond}
    {...props}
  />
);

export default TimePicker;
